import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { IoArrowBack } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";
import { HiOutlineHome, HiOutlineShieldCheck } from "react-icons/hi2";
import { TbClipboardCheck, TbFileInfo } from "react-icons/tb";

import styles from "./ReKycConfirm.module.scss";
import { clevertap_address_confirmation_screen_click } from "../../lib/clevertap-events";
import EMIsAPI from "../../services/emi-api";
import EnterFather from "./components/EnterFather";
import ServicesAPI from "../../services/services";
import Swal from "sweetalert2";

export default function ReKycConfirm() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [addressChanged, setAddressChanged] = useState(false);
  const [fatherName, setFatherName] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const { selectedLoan } = useSelector((state) => state.register);

  const { addFatherNameAPI } = new ServicesAPI();

  const loanAmount = selectedLoan?.AmountDetails?.Amount;

  const handleAddressSelection = async (changed) => {
    setAddressChanged(changed);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedName = fatherName.trim().replace(/\s+/g, " ");

    if (!data?.father_name) {
      if (trimmedName.length < 2) {
        Swal.fire({
          icon: "error",
          title: "Invalid Father's Name",
          text: "Father's name must be at least 2 characters.",
        });
        return;
      }

      await submitFatherName();
    }

    if (!addressChanged) {
      navigate("/loan-approval");
    } else {
      navigate("/re-kyc");
    }
  };

  const submitFatherName = async () => {
    try {
      const trimmedFatherName = fatherName.trim().replace(/\s+/g, " ");

      const res = await addFatherNameAPI(trimmedFatherName);

      if (res?.statusCode !== 200) {
        Swal.fire({
          icon: "error",
          text: res?.message || "Failed to save father's name.",
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error("Add father name error:", error);

      Swal.fire({
        icon: "error",
        text: "Something went wrong. Please try again.",
      });

      return false;
    }
  };

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        const { paydayEMILoanListAPI } = new EMIsAPI();
        const res = await paydayEMILoanListAPI();

        if (res?.status === "1") {
          setData(res);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAPI();
  }, []);

  return (
    <div className="wrapper auto-height">
      <header className={styles.loan_header}>
        <button type="button" className={styles.loan_header__back} onClick={() => navigate("/")} aria-label="Go Back">
          <IoArrowBack />
        </button>

        <h1 className={styles.loan_header__title}>Loan Drawdown</h1>
      </header>

      <div className={styles.confirmAddressModal}>
        <form onSubmit={handleSubmit}>
          {/* Header */}
          <div className={styles.modalHeader}>
            <div className={`${styles.iconBox} ${styles.green}`}>
              <HiOutlineShieldCheck />
            </div>

            <div className={styles.contents}>
              <h2>One last KYC check</h2>

              <p>Please confirm your details below so we can proceed with your loan.</p>
            </div>
          </div>

          {!data?.father_name && (
            <>
              <EnterFather fatherName={fatherName} setFatherName={setFatherName} devider={false} />
              <br />
            </>
          )}

          {/* Address Card */}
          <div className={styles.addressCard}>
            <div className={`${styles.iconBox} ${styles.green}`}>
              <HiOutlineHome />
            </div>

            <div>
              <h4>Current Address</h4>

              <p>
                {data?.latest_address?.address}
                <br />
                {data?.latest_address?.city}, {data?.latest_address?.state} - {data?.latest_address?.pincode}
              </p>
            </div>
          </div>

          {/* Question */}
          <div className={styles.question}>
            <div className={`${styles.iconBox} ${styles.purple}`}>
              <TbClipboardCheck />
            </div>

            <div>
              <h3>Has your address changed?</h3>

              <p>If yes, we'll help you update your KYC.</p>
            </div>
          </div>

          {/* Options */}
          <div className={styles.optionContainer}>
            <div
              className={`${styles.option} ${!addressChanged ? styles.active : ""}`}
              onClick={async () => {
                handleAddressSelection(false);
                await clevertap_address_confirmation_screen_click({
                  option: "no",
                  amount: selectedLoan?.AmountDetails?.Amount,
                });
              }}
            >
              <div className={styles.radio} />

              <span>No, my address has not changed</span>
            </div>

            <div
              className={`${styles.option} ${addressChanged ? styles.active : ""}`}
              onClick={async () => {
                handleAddressSelection(true);
                await clevertap_address_confirmation_screen_click({
                  option: "yes",
                  amount: selectedLoan?.AmountDetails?.Amount,
                });
              }}
            >
              <div className={styles.radio} />

              <span>Yes, my address has changed</span>
            </div>
          </div>

          {/* Info */}
          <div className={styles.infoBox}>
            <div className={styles.icon}>
              <TbFileInfo />
            </div>

            <p className={styles.text}>If your address has changed, we'll guide you through a quick Re-KYC using Aadhaar, DigiLocker.</p>
          </div>

          {/* Continue Button */}
          <button type="submit" className={styles.continueBtn}>
            Continue
            <FaArrowRight />
          </button>
        </form>
      </div>
    </div>
  );
}
